/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/PreUpdate/Content/TotalAffected/Content"
  
}) {
let constantData = 'This update will impact'
let automationUpdateImpactTotalAffectedValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'update_impact.total_affected',
})
let constantData1 = ' reminders in total.'
let aggregateData = fromAggregate.join(constantData, automationUpdateImpactTotalAffectedValueData, constantData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'This update will impact'"
 data="automation.update_impact.total_affected"
 data="' reminders in total.'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}